export default {
  emptyStateMessage:
    "Rankings for this year coming soon. Please check back at a later date.",
  philter: "team-rankings-widget"
};
